import { combineReducers } from 'redux'

import { modalsReducer } from '@/bus/modals'
import { notificationsReducer } from '@/bus/notifications'
import { textsReducer } from '@/bus/texts'
import { uiReducer } from '@/bus/ui'
import { userReducer } from '@/bus/user'

const rootReducer = combineReducers({
  modals: modalsReducer,
  ui: uiReducer,
  user: userReducer,
  texts: textsReducer,
  notifications: notificationsReducer
})

export default rootReducer

export type IRootState = ReturnType<typeof rootReducer>
